import ImpactHeader from "../components/header/ImpactHeader";
import Payment from "../components/paymentPage/Payment";
import SideBar from "../components/sidebar/Sidebar";


export default function PaymentLayout ({ rows }) {

    return (
        <div>
            <SideBar />
            <ImpactHeader />
            <div className="impact-main-app-content">
                <Payment />
            </div>
        </div>
    )
}